<template>
	<div class="landpage-search" :style="corPrimaria" :class="{ slim: mode === 'slim' }">
		<template v-if="mode !== 'slim'">
			<div>
				<h2 :style="'color: var(--color);'">{{ title == "" ? "Acerte aqui" : title }}</h2>
				<h2 :style="'color: var(--hovercolor);'">{{ title2 == "" ? "suas dívidas" : title2 }}</h2>
			</div>
			<h5>
				{{ parceiro && parceiroConfig.sessoes.header.campos ? parceiroConfig.sessoes.header.campos.subtitle : "É seguro, rápido e online!" }}
			</h5>
		</template>
		<div class="box-button">
			<the-mask v-model="identification" ref="inputIdentification" pattern="[0-9]*" inputmode="numeric" :mask="['###.###.###-##', '##.###.###/####-##']" :placeholder="'Digite seu CPF ou CNPJ'" @keyup.enter.native="validIdentification" :style="corPrimaria" />
			<button :style="corPrimaria" @click="validIdentification">
				<i class="fas fa-search" />
				<a>{{ "Buscar minhas dívidas" }}</a>
			</button>
		</div>
		<span v-if="messageError"> Digite um CPF ou CNPJ válido! </span>
	</div>
</template>

<script>
import { mapActions, mapState } from "vuex";
import { TheMask } from "vue-the-mask";
import Template from "../../admin/Template";
import globalMethods from "../../../mixins/globalMethods";
export default {
	name: "LandPageSearch",
	mixins: [globalMethods],
	props: ["mode"],
	components: { Template, TheMask },
	data() {
		return {
			identification: "",
			messageError: false
		};
	},
	mounted() {
		this.$refs.inputIdentification.$el.focus();
	},
	computed: {
		...mapState({
			parceiro: (state) => state.parceiro,
			parceiroConfig: (state) => state.parceiroConfig,
			corPrimaria: (state) => state.corPrimaria,
			corSecundaria: (state) => state.corSecundaria
		}),
		title: function () {
			var title = "";
			if (this.parceiroConfig.sessoes.header.campos != null && this.parceiroConfig.sessoes.header.campos.title != null) {
				var res = this.parceiroConfig?.sessoes?.header?.campos?.title.split(" ");
				var i;
				for (i = 0; i < res.length / 2; i++) {
					title += res[i] + " ";
				}
			}
			return title;
		},
		title2: function () {
			var title2 = "";
			if (this.parceiroConfig.sessoes.header.campos != null && this.parceiroConfig.sessoes.header.campos.title != null) {
				var res = this.parceiroConfig?.sessoes?.header?.campos?.title.split(" ");
				var i;
				if (res.length % 2 == 1) {
					for (i = res.length / 2 + 0.5; i < res.length; i++) {
						title2 += res[i] + " ";
					}
				} else {
					for (i = res.length / 2; i < res.length; i++) {
						title2 += res[i] + " ";
					}
				}
			}
			return title2;
		}
	},
	_methods: {
		...mapActions(["action_getCpfCnpj"]),
		searchIdentification() {
			if (this.removeMaskCharacters(this.identification).length === 11) {
				this.$router.push({
					name: "ConfirmBirthday",
					params: { identification: this.identification }
				});
			} else {
				this.messageError = false;
				this.action_getCpfCnpj({
					cpfCnpj: this.removeMaskCharacters(this.identification),
					acceptCookies: localStorage.getItem("acceptCookies") !== undefined
				}).then((response) => {
					if (response.data.retorno && response.data.dados) {
						this.$router.push({ name: "AccordionTabs" });
					} else {
						this.$router.push({ name: "Register", params: { identification: this.removeMaskCharacters(this.identification) } });
					}
				});
			}
		},
		validIdentification() {
			if (this.identification.length == 11) {
				var Soma;
				var Resto;
				Soma = 0;
				var strCPF = this.identification;
				if (strCPF == "00000000000") return (this.messageError = true);

				for (i = 1; i <= 9; i++) Soma = Soma + parseInt(strCPF.substring(i - 1, i)) * (11 - i);
				Resto = (Soma * 10) % 11;

				if (Resto == 10 || Resto == 11) Resto = 0;
				if (Resto != parseInt(strCPF.substring(9, 10))) return (this.messageError = true);

				Soma = 0;
				for (i = 1; i <= 10; i++) Soma = Soma + parseInt(strCPF.substring(i - 1, i)) * (12 - i);
				Resto = (Soma * 10) % 11;

				if (Resto == 10 || Resto == 11) Resto = 0;
				if (Resto != parseInt(strCPF.substring(10, 11))) return (this.messageError = true);

				this.searchIdentification();
			} else if (this.identification.length == 14) {
				var c = this.identification;
				var b = [6, 5, 4, 3, 2, 9, 8, 7, 6, 5, 4, 3, 2];

				if ((c = c.replace(/[^\d]/g, "")).length != 14) return (this.messageError = true);

				if (/0{14}/.test(c)) return (this.messageError = true);

				for (var i = 0, n = 0; i < 12; n += c[i] * b[++i]);
				if (c[12] != ((n %= 11) < 2 ? 0 : 11 - n)) return (this.messageError = true);

				for (var i = 0, n = 0; i <= 12; n += c[i] * b[i++]);
				if (c[13] != ((n %= 11) < 2 ? 0 : 11 - n)) return (this.messageError = true);
				this.searchIdentification();
			} else {
				return (this.messageError = true);
			}
		}
	},
	get methods() {
		return this._methods;
	},
	set methods(value) {
		this._methods = value;
	}
};
</script>

<style scoped lang="scss">
.landpage-search {
	display: flex;
	justify-content: center;
	align-items: center;
	flex-direction: column;
	div {
		display: flex;
		flex-direction: row;
		@media only screen and (max-width: 700px) {
			flex-flow: column;
		}
		h2 {
			font-size: 70px;
			color: var(--color);
			font-family: "Montserrat-Bold";
			margin-left: 20px;
			@media only screen and (max-width: 960px) {
				text-align: center;
				font-size: 50px;
			}
			@media only screen and (max-width: 700px) {
				font-size: 30px;
				display: flex;
				flex-flow: column;
				margin-left: 0px;
			}
			@media only screen and (max-width: 320px) {
				font-size: 25px;
				display: flex;
				flex-flow: column;
				margin-left: 0px;
			}
		}
	}
	h5 {
		margin: 30px 0;
		font-size: 18px;
		color: var(--grayColor);
		font-family: Cabin;
		@media only screen and (max-width: 700px) {
			font-size: 16px;
			margin: 20px 0;
		}
		@media only screen and (max-width: 320px) {
			font-size: 10px;
			margin: 10px 0;
		}
	}

	input {
		height: 60px;
		width: 300px;
		text-align: center;
		background: var(--whiteColor);
		border: 3px solid var(--whiteColor);
		border-right: 0;
		border-top-left-radius: 25px;
		border-bottom-left-radius: 25px;
		font-family: "Montserrat-Bold";
		font-size: 20px;
		color: var(--hovercolor);
		border: 1px solid var(--color);
		@media only screen and (max-width: 700px) {
			width: 75vw;
			height: 50px;
			border-top-right-radius: 25px;
			border-bottom-right-radius: 25px;
			margin-bottom: 10px;
		}
		@media only screen and (max-width: 320px) {
			width: 70vw;
			height: 40px;
			border-top-right-radius: 25px;
			border-bottom-right-radius: 25px;
			margin-bottom: 10px;
		}
	}
	button {
		background-color: var(--color);
		transition: all 0.2s ease-in-out;
		cursor: pointer;
		width: 300px;
		height: 60px;
		border-top-right-radius: 25px;
		border-bottom-right-radius: 25px;
		color: var(--whiteColor);
		border: 0;
		a {
			font-size: 16px;
			font-family: Cabin;
		}
		i {
			font-size: 20px;
			margin-right: 5px;
			@media only screen and (max-width: 700px) {
				font-size: 18px;
			}
		}
		&:hover {
			background-color: var(--hovercolor);
			transition: all 0.2s ease-in-out;
		}
		@media only screen and (max-width: 700px) {
			width: 75vw;
			height: 50px;
			border-top-left-radius: 25px;
			border-bottom-left-radius: 25px;
		}
		@media only screen and (max-width: 320px) {
			width: 70vw;
			height: 40px;
			border-top-right-radius: 25px;
			border-bottom-right-radius: 25px;
			margin-bottom: 10px;
		}
	}
	span {
		margin-top: 10px;
		color: var(--dangerColor);
		@media only screen and (max-width: 700px) {
			font-size: 12px;
			margin-top: 1px;
		}
		@media only screen and (max-width: 320px) {
			font-size: 10px;
			margin-top: 0px;
		}
	}
	@media only screen and (max-width: 1024px) {
		padding-bottom: 180px;
	}
	@media only screen and (max-width: 800px) {
		padding-bottom: 150px;
	}
}

.landpage-search .box-button {
	display: flex;
	align-items: center;
	box-sizing: border-box;
	@media only screen and (max-width: 700px) {
		flex-direction: column;
	}
}

.landpage-search input::placeholder {
	color: var(--grayColor);
	font-size: 16px;
	font-family: Cabin;
}

.landpage-search button .message-invalid {
}
</style>
